import React from 'react';

const KR = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_117"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_117)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 7.5C14 9.433 12.433 11 10.5 11C8.567 11 7 9.433 7 7.5C7 6.38 9.35 5.91 11.328 6.087C11.538 6.031 11.764 6 12 6C13.105 6 14 6.672 14 7.5Z"
        fill="#0048AB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7C10 7 10.895 6 12 6C13.105 6 14 6.672 14 7.5C14 5.567 12.433 4 10.5 4C9.103 4 7.897 4.818 7.336 6.002C7 7 7 7.292 7 7.5C7.5 8 8.056 8 8.5 8C8.944 8 9.343 7.807 9.618 7.5L10 7Z"
        fill="#CD0027"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 5H17L15 3H14L15 5ZM6 5H4L6 3H7L6 5ZM15 10H17L15 12H14L15 10ZM6 10H4L6 12H7L6 10Z"
        fill="#252526"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default KR;
